module.exports = __webpack_public_path__ + "media/4.de1e9d05.wav";